import React from 'react'
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function AddProductTypesView(props) {
    return (
        <React.Fragment>
            <div className="app-card mb-3 mb-lg-4" >
                <div className="product-filter-card">
                    <div className="card-product-type">
                        <Row>
                            <Col lg={8}>
                                <div className="mb-4">
                                    <div className="st-fs-16 st-fw-600">Create a new product attribute</div>
                                    <p >Navigate to <span className="text-primary"><Link to="/settings/product-types" className="text-decoration-none">Product Types</Link></span> and create an attribute that your products will share.</p>
                                </div>
                                <div className="mb-4">
                                    <div className="st-fs-16 st-fw-600">Specify attribute values</div>
                                    <p >Open for editing products which you want this attribute to be assigned to and specify the attribute value for each product.</p>
                                </div>
                                <div className="mb-4">
                                    <div className="st-fs-16 st-fw-600">Add the created attribute as a filter</div>
                                    <p >Get back to this page (Products Filters &gt; Add new) and add the new attribute as a filter. Once added, it will become available on the storefront.</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}